import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TimeframeFetcher } from '../utils/timeFrameFetcher';
import { apiFetch } from '../utils';

const LockChangeLabel = ({
  schoolYearType, schoolYearId, timeframeFetcher, onLockToggle
}) => {
  const [isLocked, setIsLocked] = useState(true);
  const [currentTimeframe, setCurrentTimeframe] = useState('');

  useEffect(() => {
    if (schoolYearType && schoolYearId) {
      timeframeFetcher.fetchTimeframe(schoolYearType, schoolYearId)
        .then((timeframe) => {
          setCurrentTimeframe(timeframe);
          setIsLocked(true);
        });
    }
  }, [schoolYearType, schoolYearId, timeframeFetcher]);

  if (currentTimeframe === null || currentTimeframe === undefined || currentTimeframe === '') {
    return '';
  }

  const toggleLock = () => {
    const newState = !isLocked;
    setIsLocked(newState);
    if (onLockToggle) {
      onLockToggle(newState);
    }
  };

  return (
    <span
      className='lock-control'
      data-locked-icon='fa fa-lock'
      data-locked-text={`This is a ${currentTimeframe} school year. Unlock to make changes.`}
      data-unlocked-text={`You are making changes to a ${currentTimeframe} school year.`}
      onClick={toggleLock}
      data-state={isLocked ? 'locked' : 'unlocked'}
    />
  );
};

LockChangeLabel.propTypes = {
  schoolYearType: PropTypes.string,
  schoolYearId: PropTypes.string,
  timeframeFetcher: PropTypes.objectOf(TimeframeFetcher),
  onLockToggle: PropTypes.func
};

LockChangeLabel.defaultProps = {
  schoolYearType: 'enrollment',
  schoolYearId: null,
  timeframeFetcher: new TimeframeFetcher(apiFetch),
  onLockToggle: () => {}
};

export default LockChangeLabel;
